import { useNavigate } from "react-router-dom";

import APButton from "./APButton";

const BackButton = ({ onClick }: { onClick?: () => void }) => {
  const navigate = useNavigate();

  return <APButton text="Back" onClick={onClick || (() => navigate(-1))} />;
};

export default BackButton;
